import React from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../modules/login";
import Hero from "../components/ui-library/Hero/Hero";
import Card from "../components/ui-library/HomeCard/HomeCard";
import styled, { withTheme } from "styled-components";
import beyondxlh_logo from "../assets/beyondxlh_logo.png";
import { useTranslation } from "react-i18next";
import { urlStudies } from "../modules/constants";
import { currentStudy } from "../config";

const StyledContent = styled.div`
  background-color: ${(props) => props?.theme?.bg};
  color: ${(props) => props?.theme?.fg};
  .xlh {
    font-weight: 100;
  }
`;

const Landing = () => {
  const { t } = useTranslation();

  const showBeyondXlhSection = [urlStudies.beyondxlh402].includes(
    currentStudy().toUpperCase()
  );
  const showLcf402Section = [urlStudies.lcfaod402].includes(
    currentStudy().toUpperCase()
  );

  return (
    <StyledContent id="content" className="container-fluid">
      <>
        <Hero
          header={t("appText.landing.header.welcome")}
          bodyText={t("appText.landing.body.welcome")}
        />
        {showBeyondXlhSection && (
          <Card
            renderHeader={
              <h3>
                About <i>BEYOND</i>
                <span className="xlh ml-1">XLH®</span>
              </h3>
            }
            bodyText={t("appText.landing.body.bxlh")}
            logo={beyondxlh_logo}
          />
        )}
        {showLcf402Section && (
          <Card
            header={t("appText.landing.header.lcfaod")}
            bodyText={t("appText.landing.body.lcfaod")}
          />
        )}
        <Card
          header={t("appText.landing.header.ultragenyx")}
          bodyText={t("appText.landing.body.ultragenyx")}
          buttonText="Learn more"
          btnAction={() => window.open("https://www.ultragenyx.com/", "_blank")}
          primaryButton={true}
        />
      </>
    </StyledContent>
  );
};

export default connect(mapStateToPropsLogin, null)(withTheme(Landing));
